var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-row"},[_c('div',{staticClass:"travel-service"},[_c('div',{staticClass:"content"},[(_vm.cbHtml)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.cbHtml)}}):_c('el-empty',{staticStyle:{"height":"555px"},attrs:{"description":"暂无数据"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a0932c5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/news-tidal/news-tidal-details/news-tidal-details.vue
// module id = it40
// module chunks = 1